import {
  AxiosMethod,
  defaultAxiosOptions,
  serviceEndpoints,
} from '../../constants';
import { UserModel } from '../../models';
import { AxiosRequestConfig } from 'axios';
import useAxios from 'axios-hooks';

export function useGetFilterUsers(): UserModel[] {
  const config: AxiosRequestConfig = {
    method: AxiosMethod.Get,
    url: serviceEndpoints.filterUsers(),
  };

  const [resp] = useAxios<UserModel[]>(config, {
    ...defaultAxiosOptions,
    manual: false,
  });

  return resp.data;
}
